<template>
  <section class="promotions">

    <div class="banner half-vh">
      <img class="banner-image" src="./../assets/images/large/photo-store-locator.jpg" alt=""
        v-bind:srcset="photos.xs + ' 320w, ' + photos.s + ' 768w, ' + photos.m + ' 1440w, ' + photos.l + ' 1920w'"
      >
    </div>
    <div class="container" id="promotions">
      <div class="text-content-wrapper">
        <h1>Promotions</h1>
        <button class="btn btn-primary btn-lg find-closest" type="button" v-on:click="findClosestStore">
          Find Closest Store <icon name="chevron-right" class="chevron-right-icon"></icon>
        </button>
        <div class="form-group search-form-group">
          <icon name="search" class="search-icon"></icon>
          <input type="text" class="form-control" id="search" v-model="storeFilter" name="search" placeholder="Search">
        </div>
        <ul class="stores">
          <li v-for="(store, index) in filteredStores" v-on:click="onStoreChange(store)">
            {{store.name}}
          </li>
        </ul>
      </div>
    </div>

    <div class="banner-wrapper" v-bind:class="{ active: banner.active }">
      <button class="close" type="button" name="button" v-on:click="banner.active = false;">
        <icon name="times" class="times-icon"></icon>
      </button>

      <div class="leaflet" v-leaflet v-show="promotionItems.length">
        <ul class="pages">
          <li class="page" v-for="promotionItem in promotionItems">
            <img v-bind:src="promotionItem.coverImageUrl" alt="" />
            <a style="color:#d51d2f;z-index:999;position:absolute;bottom:0;left:0;width:100%;text-align:center;font-weight:bold;height:30px;" v-bind:href="promotionItem.documentUrl" target="_blank">View Promotion</a>
          </li>
          <li class="clearfix"></li>
        </ul>

        <div class="next-page"><icon class="icon" name="chevron-right"></icon></div>
        <div class="prev-page"><icon class="icon" name="chevron-left"></icon></div>
      </div>

      <div v-show="!currentStore" style="height: 100%; display: flex;align-items: center;justify-content: center;"><h4>Please select your nearest store to view our latest specials.</h4></div>
      <div v-show="currentStore && promotionItems.length === 0" style="height: 100%; display: flex;align-items: center;justify-content: center;"><h4>There are currently no promotions for your selected store.</h4></div>
    </div>
  </section>
</template>

<script>

import { createClient } from "contentful";

const client = createClient({
  space: "r4kjztul5agf",
  accessToken: "woQwhNRxg--st0klHyPAvNk5tQF6q0HpjB1TqSk2EtE"
});

var photos = {
  xs: require('./../assets/images/x-small/photo-store-locator_xs.jpg'),
  s: require('./../assets/images/small/photo-store-locator_s.jpg'),
  m: require('./../assets/images/medium/photo-store-locator_m.jpg'),
  l: require('./../assets/images/large/photo-store-locator.jpg')
}

export default {
  name: 'promotions',
  created: function () {
    client.getEntries({
      content_type: "store"
    }).then(function(response) {
      this.$data.stores = response.items.map(store => {
        const id = store.sys.id;
        const { displayName } = store.fields;

        return {
          id,
          name: displayName
        }
      })
    }.bind(this));

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      }.bind(this))
    }
  },
  data () {
    return {
      stores: [],
      currentStore: null,
      storeFilter: '',
      promotionItems: [],
      banner: {
        active: false
      },
    }
  },
  methods: {
    findClosestStore: function () {
      if (!this.currentLocation) {
        return
      }

      client.getEntries({
        content_type: "store",
        "fields.location[near]": this.currentLocation.lat + "," + this.currentLocation.lng,
        "limit": 1
      }).then(function(response) {
        if (response.items.length > 0) {
          const nearestStore = response.items[0];
          const id = nearestStore.sys.id;
          const { displayName } = nearestStore.fields;

          this.$data.storeFilter = displayName;

          const store = this.$data.stores.filter(item => item.id === id);

          if (store.length > 0) {
            this.onStoreChange(store[0]);
          }
        }
      }.bind(this));
    },
    onPromotionClick: function (promotionItem) {
      window.open(promotionItem.documentUrl,'_blank');
    },
    onStoreChange: function (store) {
      this.$data.currentStore = store;

      client.getEntries({
        content_type: "promotion",
        include: 2,
        "fields.stores.sys.id": store.id
      }).then(function (response) {

        const parsedPromotionItems = [];
        response.items.forEach(promotion => {
          const { promotionItems } = promotion.fields;

          promotionItems.forEach(promotionItem => {
            const { name, coverImage, document } = promotionItem.fields;
            const coverImageUrl = coverImage.fields.file.url;
            const documentUrl = document.fields.file.url;

            parsedPromotionItems.push({
              name, 
              coverImageUrl, 
              documentUrl
            })
          });
        })

        this.$data.promotionItems = parsedPromotionItems;
      }.bind(this));

      this.$data.banner.active = true
    }
  },
  computed: {
    photos () { return photos },
    filteredStores: function () {
      var storeFilter = this.$data.storeFilter.toLowerCase()

      var ordered = _.orderBy(this.$data.stores, ['name'], ['asc'])

      if (!storeFilter || storeFilter === '') {
        return ordered
      }

      var filtered = _.filter(ordered, function (store) {
        // return true
        var name = store.name.toLowerCase()
        return name.toLowerCase().indexOf(storeFilter) >= 0
      })
      return filtered
    }
  },
  directives: {
    leaflet: {
      // directive definition
      inserted: function (el) {
        var dragging = false

        var containerWidth = el.offsetWidth

        var pages = el.getElementsByClassName('pages')[0]
        var pagesWidth = pages.offsetWidth
        var pageWidth = 0
        // setPagesWidth()

        var scrollSize = pagesWidth - containerWidth

        var next = el.getElementsByClassName('next-page')[0]
        var prev = el.getElementsByClassName('prev-page')[0]

        var mouseX = 0
        var prevMouseX = 0
        var deltaMouseX = 0
        var pageLeft = 0

        el.addEventListener('mousedown', scrollStart)
        el.addEventListener('touchstart', scrollStart)
        document.addEventListener('mouseup', scrollEnd)
        document.addEventListener('touchend', scrollEnd)
        el.addEventListener('mousemove', scrollMove)
        el.addEventListener('touchmove', scrollMove)

        next.addEventListener('click', nextTriggered)
        next.addEventListener('touchstart', nextTriggered)

        prev.addEventListener('click', prevTriggered)
        prev.addEventListener('touchstart', prevTriggered)

        window.addEventListener('resize', function () {
          setPagePosition(0)
          scrollSize = pagesWidth - containerWidth
        })

        function nextTriggered (e) {
          pages.classList.add('animate')
          var newPagePos = 0

          var safety = 0
          while (newPagePos >= pageLeft && safety < 20) {
            safety++
            newPagePos -= pageWidth
          }

          setPagePosition(newPagePos)
        }

        function prevTriggered (e) {
          pages.classList.add('animate')
          var newPagePos = -scrollSize

          var safety = 0
          while (newPagePos <= pageLeft && safety < 20) {
            safety++
            newPagePos += pageWidth
          }

          setPagePosition(newPagePos)
        }

        function scrollStart (e) {
          //e.preventDefault()
          pages.classList.remove('animate')

          mouseX = getRelativeMouseX(event)
          prevMouseX = mouseX
          dragging = true
        }

        function scrollEnd (e) {
          //e.preventDefault()
          dragging = false
        }

        function scrollMove (e) {
          if (dragging) {
            mouseX = getRelativeMouseX(event)
            deltaMouseX = prevMouseX - mouseX
            prevMouseX = mouseX
            setPagePosition(pageLeft - deltaMouseX)
          }
        }

        function getRelativeMouseX (event) {
          var x = 0

          if (event.changedTouches) {
            x = event.changedTouches[0].pageX
          } else {
            x = event.pageX
          }

          return x - el.offsetLeft
        }

        function setPagesWidth () {
          scrollSize = pagesWidth - containerWidth
          var pageElements = pages.getElementsByClassName('page')

          if (!(pageElements && pageElements.length > 0)) {
            return
          }

          pageWidth = pageElements[0].offsetWidth

          var newPagesWidth = 0
          for (var i = 0; i < pageElements.length; i++) {
            newPagesWidth += pageElements[i].offsetWidth
          }
          pagesWidth = newPagesWidth + 1

          // if (pages.style.width !== pagesWidth + 'px') {
          pages.style.width = pagesWidth + 'px'
          // }
        }

        function setPagePosition (pagePosition) {
          setPagesWidth()

          if (prev.classList && next.classList) {
            prev.classList.remove('hide')
            next.classList.remove('hide')
          }

          if (pagePosition > 0) {
            pagePosition = 0
          }

          if (pagePosition < -scrollSize) {
            pagePosition = -scrollSize
          }

          pageLeft = pagePosition

          if (next.classList && pageLeft < (-scrollSize + 10)) {
            next.classList.add('hide')
          }

          if (prev.classList && pageLeft > -10) {
            prev.classList.add('hide')
          }

          pages.style.transform = 'translateX(' + pageLeft + 'px)'
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours.scss';
  @import '../scss/mixins.scss';
  @import '../scss/loader.scss';

  section{
    position: relative;

    @include breakpoint(lg){
      padding: 0;
    }
  }

  .banner{
    margin-bottom: 0;
  }

  @include breakpoint(lg){

    .banner-image{
      margin-top: -7%;
    }

    .page > section .text-content-wrapper{
      padding: 2em;
    }
  }

  .find-closest{
    cursor: pointer;
    width: 100%;
    background-color: $blue;
    border: none;

    .chevron-right-icon{
      height: 20px;
      width: auto;
      margin-left: 5px;
      margin-bottom: -3px;
    }

    &:hover{
      background-color: lighten($blue, 5%);
    }

    &:active{
      background-color: $blue-dark;
    }
  }

  .search-form-group{
    margin: 1em 0;
    position: relative;
  }

  .search-icon{
    position: absolute;
    right: 0;
    top: 10px;
  }

  input{
    padding: 10px 0 5px 0;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid $red;
  }

  ul.stores{
    list-style: none;
    padding: 0;
    margin: 0;
    display: block;
    border-radius: 4px;
    height: 400px;
    height: 33.5vh;
    overflow-y: scroll;
    font-family: Helvetica, Arial, sans-serif;

    @include breakpoint(lg){
      position: absolute;
      top: 220px;
      bottom: 2em;
      left: 2em;
      right: 2em;
      height: auto;
    }

    li{
      cursor: pointer;
      display: block;
      padding: 10px 10px;
      color: white;
      background: $red;
      margin-bottom: 1px;

      &:hover{
        background: lighten($red, 5%);
      }

      &:active{
        background: $red-dark;
      }

      &:first-child{
        border-radius: 4px 4px 0 0;
      }

      &:last-child{
        border-radius: 0 0 4px 4px;
      }
    }
  }

  section > .container{
    @include breakpoint(lg){
      z-index: 76;
      position: relative;
      width: 350px;
      min-height: 450px;
      height: 50vh;
      float: left;
      background-color: white;
      padding: 0;
      margin: 0;
    }
  }

  .banner-wrapper{
    background-color: #ffffff;
    //display: none;
    z-index: 75;
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease-in-out;

    @include breakpoint(lg){
      pointer-events: auto;
      opacity: 1;
      position: relative;
      top: auto;
      right: auto;
      bottom: auto;
      padding-left: 350px;
      width: 100%;
      min-height: 450px;
      height: 50vh;
    }

    &.active{
      //display: block;
      pointer-events: auto;
      opacity: 1;
    }

    button.close{
      position: absolute;
      z-index:100;
      top: 10px;
      right: 10px;
      width: 40px;
      height: 40px;
      background-color: none;
      color: $red;
      opacity: 1;
      padding: 0;

      @include breakpoint(lg){
        display: none;
      }

      .times-icon{
        width: auto;
        height: 1.5em;
      }
    }
  }

  .leaflet{
    position: relative;
    height: 100%;
    width: 100%;
    /*padding-bottom: 60%;
    margin-top: 40px;*/
    overflow: hidden;
    /*background-color: #ececec;*/

    @media (orientation: portrait){
      padding-bottom: 110%;
    }

    .pages{
      position: absolute;
      top: 0;
      left: 0;
      width: 9999px;
      height: 100%;
      margin: 0;
      padding: 0;

      &.animate{
        transition: transform 0.25s ease-in-out
      }

      li{
        position: relative;
        list-style: none;
      }
    }

    .page{
      padding: 20px 20px 40px 20px;
      height: 100%;
      float: left;

      img{
        height: 100%;
        width: auto;
        opacity: 1;
        transition: opacity 0.5s ease-in-out;

        &.loading{
          opacity: 0;
        }
      }
    }

    .next-page{
      position: absolute;
      top: 0;
      right: 0;
    }

    .prev-page{
      position: absolute;
      top: 0;
      left: 0;
    }

    .prev-page, .next-page{
      width: 30px;
      padding: 5px;
      height: 100%;
      background-color: rgba(white, 0.75);

      @include breakpoint(md){
        width: 50px;
        padding: 10px;
      }

      &.hide{
        opacity: 0;
      }

      .icon{
        color: $blue;
        width: 100%;
        height: 100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Promotions.vue